import * as React from "react";
import { Row, Col, ListGroup, Button } from "react-bootstrap";
import { PublicRoutes, useAppSelector, ConfigKeys, AppConfiguration, DefaultRoutes } from "src/common";
import { RootState } from "src/store/configureStore";

function UpgradeInformationComponent() {
  const user_id = useAppSelector((state: RootState) => state.account.current_account?.user_id);
  const local_app_server = AppConfiguration.getConfigValue(ConfigKeys.local_app_server);

  return (
    <>
      <Row className="justify-content-center">
        <Col xs={10} md={9}>
          <h1 className="mb-2">Upgrade your PreVeil Express Account</h1>
          <p className="mb-3 fs-3 text-primary">Install on a Mac or PC</p>
          <p className="mb-4 fs-4">
            If you can <b>download software</b> to your computer, then you can take advantage of the full PreVeil account. The platform integrates seamlessly
            with Outlook, Gmail, File Explorer and Mac Finder.
          </p>
          <ListGroup className="public-card" horizontal>
            <ListGroup.Item className="align-center justify-content-center image">
              <div className="option-counter">1</div>
            </ListGroup.Item>
            <ListGroup.Item className="content">
              <p className="title bold">Download PreVeil Application</p>
              <p className="fs-4">
                Navigate to <b className="text-primary text-break">https://www.preveil.com/download</b> and select the download button for your type of device.
              </p>
            </ListGroup.Item>
          </ListGroup>
          <ListGroup className="public-card" horizontal>
            <ListGroup.Item className="align-center justify-content-center image">
              <div className="option-counter">2</div>
            </ListGroup.Item>
            <ListGroup.Item className="content">
              <p className="title bold">Upgrade</p>
              <p className="fs-4">
                Login to your PreVeil Express account to begin upgrading to your <b>full featured PreVeil account</b>
              </p>
              <Button
                href={
                  !!user_id
                    ? `${local_app_server}/${PublicRoutes.upgrade_account_route}?user_id=${encodeURIComponent(
                      user_id,
                    )}`
                    : `${local_app_server}/${PublicRoutes.upgrade_account_route}`
                } >
                Begin Upgrading
              </Button>
            </ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs={10} md={9} className="text-end">
          <Button
            className="bold"
            variant="link"
            size="lg"
            href={`${DefaultRoutes.mail_default}`}>Cancel</Button>
        </Col>
      </Row>
    </>
  );
}

export default React.memo(UpgradeInformationComponent);
